import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { AiFillCaretRight, AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";

const SmartDevices = () => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-home-loan-banner.png";
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/SmartDevicesNew-2.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accountContent = "Smart devices and other portable devices such as Laptops, Mobile phones, tablets and Cameras.";

  
  const [openIndex, setOpenIndex] = useState(null);


  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionData = [
    {
      title: "Features",
      content: [
        "Riot & civil commotion – Non-Political",
        "Worldwide cover",
        "Power surges and indirect lighting strikes – Excluding power utility company schedule operational/ load shedding programs and subject to lightning and overvoltage protection devices",
        "Fall from heights- 20% policy excess to apply with a minimum of k1,000.00",
        "Malicious damage",
        "10% minimum ZMW 500 each and every claim including theft claims",
        "Double excess for fall from heights claims",
      ],
    },
    {
      title: "Requirements",
      content: [
        "Photos of the smart device to be insured", 
        "Serial number",
        "Correct replacement value",
        "Schedule of the devices to be covered with above information if two or more gadget are to be cover",
      ],
    },
    {
      title: "Basis of cover",
      content: [
        "All risks of physical loss or damage by any cause to the insured item unless those specifically and explicitly excluded by the policy.",
      ],
    },
    {
      title: "Settlement",
      content: ["Replacement or reinstatement value."],
    },
    {
      title: "Some Notable Exclusions Among Others",
      content: [
        "Wear and Tear",
        "Mechanical, electronic or electrical faults",
        "Unexplained or mysterious losses",
        "Willful acts",
        "Consequential loss",
        "Political, terrorism and war risks",

      ],
    },
    {
      title: "How to Apply",
      content: ['To apply now, email <a href="mailto:bancassurance@izb.co.zm">bancassurance@izb.co.zm</a> or call <a href="tel:8002">8002</a>'],
    }
  ];

  return (
    <>
       <section className="HouseOwnersInsuranceSection">
        <Breadcrumb Heading="Smart Devices" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
       </section>

       <SavePlusAccountComponent heading="Smart Devices" subHeading="Know About" btnTxt="Apply Now" content={accountContent} img={img1} logo={true} />
       {/* <ContainsArea /> */}

        <section>
            <div className="container">
            <div className="row">
                <div className="col-xl-12 justify-content-center">
                <div className="faq-style1__content">
                    <ul className="accordion-box mt-2" style={{paddingBottom: "50px"}}>
                        {accordionData.map((item, index) => (
                            <li className="accordion block active-block" key={index}>
                                <div
                                    className="acc-btn active"
                                    style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                                    onClick={() => handleToggle(index)}
                                >
                                    <div className="icon-outer text-white">
                                        {openIndex === index ? <AiOutlineArrowRight /> : <AiOutlineArrowUp />}
                                    </div>
                                    <h3 className="text-white">{item.title}</h3>
                                </div>
                                {openIndex === index && (
                                    <div className="acc-content current px-5">
                                        {item.content.map((point, idx) => (
                                            <p key={idx} className="">
                                                <AiFillCaretRight className="me-1 accordion-icon" />
                                                <span className="mt-1" dangerouslySetInnerHTML={{ __html: point }} />
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                </div>
            </div>
            </div>
        </section>

       <AllAcountsSection />
    </>
  );
};

export default SmartDevices;